import React from 'react';
import ProductCard from '../components/ProductCard';

function HomePage() {
  const dateCalculatorDesc = "A mobile application providing a streamlined interface for date-related functionalities, including chain calculations, date compare computations, and random date generation."; // Placeholder
  const rngDesc = "A versatile random number generator app, featuring dice, integers, decimals, normal distribution, custom scripts, and password generation.";
  const collectxDesc = "CollectX is a mobile-first app for scanning, identifying, and managing collectible items using AI-driven image recognition. Organize, analyze, and gain insights into your collection—all while keeping your data private and local.";
  const noteAndToDoDesc = "A minimalist, mobile-only note-taking and task management application designed for quick, efficient capture and organization of thoughts, notes, and short-term tasks.";

  return (
    <div>
      <h2>Our Apps</h2>
      <div className="product-grid">
        <ProductCard
          title="Date Calculator"
          description={dateCalculatorDesc} // Replace with actual description
          links={[
            { text: 'Terms of Service', url: '/apps/date-calculator/terms-of-service' },
            { text: 'Privacy Policy', url: '/apps/date-calculator/privacy-policy' }
          ]}
        />
        <ProductCard
          title="Random Number Generator Pro"
          description={rngDesc}
          links={[
            { text: 'Terms of Service', url: '/apps/random-number-generator/terms-of-service' },
            { text: 'Privacy Policy', url: '/apps/random-number-generator/privacy-policy' },
          ]}
        />
        <ProductCard
          title="CollectX"
          description={collectxDesc}
          links={[
            { text: 'Terms of Service', url: '/apps/collectx/terms-of-service' },
            { text: 'Privacy Policy', url: '/apps/collectx/privacy-policy' }
          ]}
        />
        <ProductCard
          title="Note & To-do"
          description={noteAndToDoDesc}
          links={[
            { text: 'Terms of Service', url: '/apps/note-and-to-do/terms-of-service' },
            { text: 'Privacy Policy', url: '/apps/note-and-to-do/privacy-policy' }
          ]}
        />
      </div>
    </div>
  );
}

export default HomePage;